/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Error_Start_RequiredInputs */



/**
* | output |
* | --- |
* | "Start date is required" |
*
* @param {Tournament_New_Error_Start_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_error_start_required = /** @type {((inputs?: Tournament_New_Error_Start_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Error_Start_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La date de début est requise")
	if (locale === "es") return /** @type {LocalizedString} */ ("La fecha de inicio es obligatoria")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A data de início é obrigatória")
	if (locale === "it") return /** @type {LocalizedString} */ ("La data di inizio è obbligatoria")
	return /** @type {LocalizedString} */ ("Start date is required")
});